import React, { useState, useEffect } from "react";
import { Button, InputAdornment, Box, OutlinedInput } from "@mui/material";
import "./login.scss";
import auth from "../../../config/auth";
import { messages } from "../../../constants/commonMessages";
import * as acts from "../../../redux/auth/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CPVLogo from "../../../assets/CPV-Auto-logo-Final.png";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import OtpModal from "../../Modal/OtpValidation/Index";
import ProgressBar from "../../ProgressBar";
import { useNavigate } from "react-router-dom";
import { extractPermissions } from "../../../utils/permissions";
import { getPostLoginRoute } from "../../../utils/landingRoute";

const LoginPage = (props) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [inValidUserErrorMessage, setInValidUserErrorMessage] = useState("");
  const [errormessage, setErrorMessage] = useState(false);
  const [isLoggedInAlready, setIsLoggedInAlready] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [otpAuthModal, setOtpAuthModal] = useState(false);
  const [otpSuccesMessage, setOtpSuccesMessage] = useState("");
  const [allLogout, setAllLogout] = useState(false);
  const [ipAddress, setIpAddress] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tagNameError, setTagNameError] = useState(false);
  const [isMessage, setIsMessage] = useState("");

  useEffect(() => {
    navigate("/", { replace: true });
    const dummyState = { dummy: true };
    window.history.pushState(dummyState, "", window.location.href);

    props.acts.clearApiResponse();
    props.acts.loginClear();
    props.acts.loginInAlreadyClear();
    props.acts.clearForgotPassLinkStatus();

    if (localStorage.getItem("token")) {
      const showNotification= false
      props.acts.userLogout(showNotification);
    }

    return () => {};
  }, []);

  useEffect(() => {
    if (props.userData.users && props.userData.users.data !== undefined) {
      if (props.userData.users.data.status === true) {
        localStorage.setItem(
          messages.TOKEN,
          props.userData.users.data.data.token
        );
        localStorage.setItem(
          messages.USER_ROLE,
          props.userData.users.data.data.role
        );
        localStorage.setItem(
          messages.USER_SUB_ROLE,
          props.userData.users.data.data.subroles
        );
        localStorage.setItem(
          messages.USER_GROUPS,
          JSON.stringify(props.userData.users.data.data.groups ?? [])
        );
        localStorage.setItem(
          messages.USER_ID,
          props.userData.users.data.data.userid
        );
        localStorage.setItem(
          messages.USER_NAME,
          props.userData.users.data.data.username
        );
        localStorage.setItem(
          messages.LAST_LOGIN,
          props.userData.users.data.data.last_login
        );
        localStorage.setItem(
          messages.PERMISSIONS,
          JSON.stringify(extractPermissions(props.userData.users.data.data))
        );
        props.acts.loginClear();

        setInValidUserErrorMessage("");
        auth.login();

        if (auth.isAuthenticated()) {
          navigateUser();
        }
      }
    } else if (
      props.userData.error !== undefined &&
      props.userData.error !== ""
    ) {
      handleErrorResponse(props);
    }

    if (
      props.forgotPasswordBoxStatus &&
      props.forgotPasswordBoxStatus !== undefined
    ) {
      handleForgotPasswordBoxStatus(props.forgotPasswordBoxStatus);
    }

    if (props.isLoggedInAlready) {
      setIsLoggedInAlready(props.isLoggedInAlready);
    }

    if (
      props.forgotPasswordLinkStatus &&
      props.forgotPasswordLinkStatus !== undefined
    ) {
      handleForgotPasswordLinkStatus(props.forgotPasswordLinkStatus);
    }

    if (props.otpStatus?.message !== "" || undefined) {
      handleOtpStatus(props?.otpStatus);
    }

    if (
      props.error?.response?.data?.message !== "" &&
      props.error?.response?.data?.message !== undefined
    ) {
      setInValidUserErrorMessage(props.error?.response?.data?.message);
      setErrorMessage(true);
    }

    if (props.otpStatus?.response?.data?.data?.is_logged_in === true) {
      setIsLoggedInAlready(true);
    }

    if (props.allUsersLogout?.apiSuccess === true) {
      setAllLogout(true);
      setIsLoggedInAlready(false);
      setInValidUserErrorMessage("");
      props.navigate("/");
    }
  }, [props]);

  const handleErrorResponse = (props) => {
    if (props?.error?.response?.data?.message === undefined) {
      setInValidUserErrorMessage(props?.userData?.error?.message);
      setIsLoading(false);
      setErrorMessage(true);
    }
    if (props?.error?.response?.data?.message === undefined) {
      setInValidUserErrorMessage(props?.userData?.error?.message);
      setIsLoading(false);
      setErrorMessage(true);
    } else {
      setInValidUserErrorMessage(props?.error?.response?.data?.message);
      setIsLoading(false);
      setErrorMessage(true);
    }
    if (
      props.error?.response?.data?.message === "Please Update Your Password"
    ) {
      setIsLoading(true);
      localStorage.setItem("invalidPassword", true);
      setTimeout(() => {
        setIsLoading(false);
        props.navigate(
          `/forgot-password/${props.error?.response?.data?.data?.hash_key}`
        );
        props.acts.loginFailClear();
      }, 2000);
    }
  };

  const handleForgotPasswordBoxStatus = (status) => {
    if (status.loader === false) {
      if (
        status.message === undefined ||
        (status.message !== "" && status?.next === true)
      ) {
        setIsFileUploaded(true);
        setIsMessage(status.message);
        props.acts.clearForgotPassLinkStatus();
      } else if (
        status.message !== "" &&
        status.loader === false &&
        status?.next !== true
      ) {
        setTagNameError(true);
        setIsMessage(status.message);
        props.acts.clearForgotPassLinkStatus();
      }
    }
  };

  const handleForgotPasswordLinkStatus = (status) => {
    if (
      status.loader === false &&
      status.next === true &&
      (status.message !== undefined || status.message !== "")
    ) {
      setIsFileUploaded(true);
      setIsMessage(status.message);
      props.acts.clearForgotPassLinkStatus();
    } else if (
      status.loader === false &&
      status.next === false &&
      (status.message !== undefined || status.message !== "")
    ) {
      setTagNameError(true);
      setIsMessage(status.message);
    }
  };

  const handleOtpStatus = (status) => {
    if (status && status.status === true && status.next === true) {
      setOtpSuccesMessage(status.message);
      setOtpAuthModal(true);
    }
  };

  const navigateUser = () => {
    setIsLoading(false);
    navigate(getPostLoginRoute(), { replace: true });
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setIsLoggedInAlready(false);
    setInValidUserErrorMessage("");
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setInValidUserErrorMessage("");
    setIsLoggedInAlready(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const user = {
      body: {
        username: email,
        password: password,
      },
    };
    props.acts.userLogin(user);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleForgotPassword = (event) => {
    event.preventDefault();
    const forgotPasswordBox = `${process.env.REACT_APP_FORGOT_PASSWORD_LINK}`;
    props.acts.forgotPasswordLink(email, forgotPasswordBox);
  };

  const handleAllUserLogout = () => {
    const data = {
      body: {
        username: email,
        password: password,
      },
    };
    props.acts.allUserLogout(data);
    setIsLoggedInAlready(false);
  };

  const handleModalClose = () => {
    setOtpAuthModal(false);
  };

  return (
    <Box component="main" className="ac-login-container-main">
      {otpAuthModal && (
        <OtpModal
          isOpenOtpModal={otpAuthModal}
          handleCloseOtpModal={handleModalClose}
          userName={email}
          message={otpSuccesMessage}
          inValidUserErrorMessage={inValidUserErrorMessage}
        />
      )}
      <div className="loginFormWrap">
        <div className="CPV_Logo">
          <img src={CPVLogo} alt="Logo" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="input-wrap">
            <label>Username</label>
            <OutlinedInput
              fullWidth={true}
              id="email"
              required
              aria-describedby="outlined-weight-helper-text"
              inputProps={{
                "aria-label": "weight",
              }}
              name="email"
              autoComplete="email"
              autoFocus
              labelwidth={0}
              value={email}
              onChange={handleEmailChange}
            />
          </div>
          <div className="input-wrap">
            <label>Password</label>
            <OutlinedInput
              fullWidth
              required
              name="password"
              size="small"
              type={showPassword ? "text" : "password"}
              aria-describedby="outlined-weight-helper-text"
              labelwidth={0}
              value={password}
              onChange={handlePasswordChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    className="input-wrap-icon"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </div>
          <div className="error">
            {inValidUserErrorMessage && (
              <label>{inValidUserErrorMessage}</label>
            )}
          </div>
          <Button
            className={
              email === "" || password === "" || isLoggedInAlready
                ? "signin-disabled"
                : "signbtn"
            }
            type="submit"
            onClick={handleSubmit}
            disabled={email === "" || password === "" || isLoggedInAlready}
          >
            Sign in
          </Button>
          {isLoggedInAlready && (
            <Button
              className="handle-logout-for-all-device"
              disabled={email === "" || !isLoggedInAlready}
              onClick={handleAllUserLogout}
            >
              Logout From All Devices
            </Button>
          )}

          <Button
            className={email === "" ? "forgetPassword-disabled" : ""}
            disabled={email === ""}
            onClick={handleForgotPassword}
            endIcon={<MailOutlineIcon />}
          >
            Forgot/Update Password
          </Button>

          <div className="support-mail">
            <p style={{ margin: 0, padding: 0 }}>
              Need help? Contact us at{" "}
              <a href="mailto:support@aventior.com" className="support-link">
                support@aventior.com
              </a>
            </p>
          </div>

          <div className="version-wrap">
            <p className="app-version-text">Application Version</p>
            <p className="app-version-number" style={{fontWeight:'700'}}> SRM 1.2</p>
          </div>
        </form>
      </div>

      {isLoading && <ProgressBar />}
      {isFileUploaded && (
        <CustomizedSnackbars
          severity="success"
          state={isFileUploaded}
          text={isMessage}
          handleClose={() => setIsFileUploaded(false)}
        />
      )}
      {allLogout && (
        <CustomizedSnackbars
          severity="success"
          state={allLogout}
          text="Successfully Logged Out"
          handleClose={() => setAllLogout(false)}
        />
      )}
      {tagNameError && (
        <CustomizedSnackbars
          severity="error"
          state={tagNameError}
          text={isMessage}
          handleClose={() => setTagNameError(false)}
        />
      )}
    </Box>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    forgotPasswordBoxStatus: state.auth.forgotPasswordBoxStatus,
    userData: state.auth,
    apiStatus: state.auth.apiStatus,
    forgotPasswordLinkStatus: state?.auth?.forgotPasswordLinkStatus,
    isLoggedInAlready: state.auth.isLoggedInAlready,
    error: state.auth.error,
    otpStatus: state.auth.otpSuccess,
    allUsersLogout: state.auth.userLogout,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
